import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m6.055 14.129-2.709 5.317 3.293-.154 1.919 2.858 2.003-3.876M17.945 14.029l2.71 5.317-3.294-.153-1.918 2.858-2.004-3.877"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.536 13.048a7.49 7.49 0 0 1-6.693 3.93c-4.053-.045-7.361-3.34-7.415-7.385C4.367 5.409 7.752 2 11.935 2c.468 0 .929.046 1.374.123a7.27 7.27 0 0 1 5.465 4.55c.26.698.337 1.38-.092 1.778C15.796 11.11 14 3.5 20.5 6.5"
    />
  </svg>
);
export const MedalIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
